export const COLOR_STATUS_VERIFICATION = 'COLOR_STATUS_VERIFICATION';
export const TEXT_STATUS_VERIFICATION = 'TEXT_STATUS_VERIFICATION';
export const IS_ACTIVE_ALERT_VERIFICATION = 'IS_ACTIVE_ALERT_VERIFICATION';
export const IS_ACTIVE_BUTTON_VERIFICATION = 'IS_ACTIVE_BUTTON_VERIFICATION';
export const IS_LOADING_FORM_VERIFICATION = 'IS_LOADING_FORM_VERIFICATION';
